import mitt from "mitt";
export const eventBus = mitt();
export const emitMessage = (message, type = "success", additional) => {
  eventBus.emit("message", { type, message, additional });
};
